// Core
import styled from 'styled-components';

export const StyledTrip = styled.div`
cursor: pointer;
position:relative;
img {
    width: 100%;
    height: 275px;
    object-fit: cover;
    border-radius: 27px;
    background: #eee;
    min-height: 275px;
    min-width: 100%;
    text-align: center;
}

h1 {
    font-size: 18px;
    margin-bottom: 5px;
    font-weight: bold;
    width: 100%;
    margin-top: 15px;
}
h4{
  border-bottom: 1px solid #7474744f;
  font-size: 15px;
    width: 100%;
    padding-bottom: 10px;
    color:#7f4d03;
}
p{
  font-size: 16px;
  color:#747474cf;
}
a{
  font-size: 16px;
  color: #0780bd !important;
  cursor: pointer;
}
.__no_desc a{
  font-size: 14px;
  font-weight: 500;

  &::after {
    content: '\\203A';
    display: inline-block;
    margin-left: 8px;
    transition: transform 0.2s;
  }
}
&:hover .__no_desc a::after {
  transform: translateX(4px);
}
.__premium{
    border-radius: 20px 0px;
    background: #e91e63;
    color: #fff;
    font-weight: bold;
    position: absolute;
    top: 30px;
    right: -10px;
    padding: 4px 10px;
}
.__visual_app{
    position: absolute;
    /* image is 275px tall: sit on its bottom-left corner, inside the picture */
    top: 275px;
    left: 14px;
    transform: translateY(calc(-100% - 14px));
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 14px 5px 10px;
    border-radius: 30px;
    background: linear-gradient(135deg, #f0c76a, #d8a74a);
    color: #2b1b00;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    box-shadow: 0 4px 12px #0005;
    pointer-events: none;

    &::before {
        content: '\\2726';
        font-size: 13px;
    }
}
`;
